var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:(_vm.props.text),expression:"props.text"}],key:_vm.props.tokey,class:_vm.props.toclass,style:(_vm.props.tostyle)},[_vm._v("\n  "+_vm._s(_vm.props.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }